import HomeHero from '../components/home/HomeHero'
import ChoicesTour from '../components/home/ChoicesTour'
import MissionsShowcase from '../components/home/MissionsShowcase'
import ComponentsBento from '../components/home/ComponentsBento'
import TemplatesBand from '../components/home/TemplatesBand'
import AccessibilityBand from '../components/home/AccessibilityBand'
import { ClosingBand, SystemStats } from '../components/home/HomeBands'
import AgentsField from '../components/home/AgentsField'
import Heritage from '../components/home/Heritage'
import DesignNotesBar from '../components/inspector/DesignNotesBar'
import { heritage } from '@/content/heritage'
import { useMissionAddress } from '@/state/useMissionAddress'

export default function HomePage() {
  useMissionAddress()
  return (
    <div className="home">
      {/* Design notes sit on the header, the hero and the components, then
          rest while the story scrolls, and return from the call to action
          down through the footer. */}
      <HomeHero />
      <ComponentsBento />
      <ChoicesTour />
      <MissionsShowcase />
      <TemplatesBand />
      <SystemStats />
      <AccessibilityBand />
      {heritage.moments.length > 0 && <Heritage />}
      <AgentsField />
      <ClosingBand />
      <DesignNotesBar />
    </div>
  )
}
